export default
Object.freeze({
  REGISTRATOR_BACKGROUND_COLOR_DEFAULT: '#34c759',
  RETURN_AFTER_PICK_TIKET_SECONDS: 7,
  DELAY_BEFORE_COUNTDOWN_PHONE_NUMBER: 20,
  DELAY_AFTER_COUNTDOWN_PHONE_NUMBER: 10
});


export const DEVICE_TYPES = Object.freeze({
  DEFAULT: 'default',
  QR_CODE: 'qr_code'
})

export const GROUP_PARAMS_ERRORS = Object.freeze({
  REQUIREMENT_ERROR: 'required_error',
  MAX_LENGTH_ERROR: 'max_length_error',
  MIN_LENGTH_ERROR: 'min_length_error',
  PHONE_ERROR: 'phone_error',
})
